import dynamic from 'next/dynamic';
import { memo } from 'react';

import { Modal } from '~components/Modals/Base';

import type { BotPaywallModalProps } from '../../model/types';

const Content = dynamic(
	() => import('./dynamicContent').then((mod) => mod.Content),
	{
		ssr: false,
	}
);

export const BotPaywallModal = memo<BotPaywallModalProps>(
	({ checkoutReason, botClientId = '', promo, redirect, onClose }) => {
		const onCloseFn = () => {
			onClose(false);
		};
		return (
			<Modal
				className="fullpage"
				open={!!botClientId}
				locked={true}
				onClose={onCloseFn}
			>
				<Content
					botClientId={botClientId}
					checkoutReason={checkoutReason}
					promo={promo}
					redirect={redirect}
					onClose={onClose}
				/>
			</Modal>
		);
	}
);
BotPaywallModal.displayName = 'BotPaywallModal';
